<script>
	export default {
		name: 'LifecycleExecuter',
		methods: {
			createdApp() {
				const self_ = this;
				// crated datetime
				const datetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
				self_.setAppState('createdDatetime', datetime_)
			},
			createdPage(pageName) {
				const self_ = this;
/* info */		self_.logInfo('Page Creation', self_.convertCaseToPascal(pageName) + ' page is opened.')
			},
			updatePage(pageName) {
				const self_ = this;
/* info */		self_.logInfo('Route Update', self_.convertCaseToPascal(pageName) + ' page is opened.')
			},
			beforeMountPage(pageName) {
				const self_ = this;
				const router_ = self_.$router;
				// excluded pages
				const excluded_ = [ 'logout' ]
				excluded_.forEach(key => {
					if(pageName == key) { return }
				})
				// hide toolbar tabs
				self_.setComponentState('showToolbarTabs', false)
				// hide messagebar footer
				if(pageName != 'timeline') {
					self_.setComponentState('showMessagebarFooter', false)
					self_.resetMessageState()
				}

				const uid_ = self_.getCurrentUser('uid')

				// page is initialized -> called from beforeMount
				// page is NOT initialized -> called after initializePage
				const initialized_ = self_.getPageState('isInitialized')
				if(initialized_[pageName]) {
					const inits_ = self_.getPageInits(pageName)
					const info_ = inits_.info;
					// check menu group
					if(self_.isFalse(self_.checkMenuGroup(info_.menuGroup))) { router_.replace('/') }
					// chech user group
					if(self_.isFalse(self_.checkSecurityGroup(info_.securityGroup))) {
						// non user -> login
						if(self_.isEmpty(uid_)) { router_.replace('/login') }
						// user -> unauthorized
						else { router_.replace('/unauthorized') }
					}
				}

				if(self_.isFalse(uid_)) { return }
					
				// reset password
				Promise.resolve().then(() => {
					return self_.getUserOptions(uid_)
				}).then(result => {
					if(!self_.isEmpty(result) && result['reset_password'] && pageName != 'resetPassword') { self_.$router.push('/reset-password') }
					else if(!self_.isEmpty(result) && result['reset_security_question'] && pageName != 'securityQuestion') { self_.$router.push('/security-question') }
				})
			},
			beforeDestroyPage(pageName) {
				const self_ = this;
				// remove search condition
				if(pageName == 'timeline') {
					self_.setComponentState('chatList', { key: null })
					self_.setComponentState('contactList', { uid: null })
					self_.setComponentState('searchbarList', { startDate: null, endDate: null, word: null, tag: null })
				}
			}
		}
	}
</script>